import PATH from "constants/path";
import React, { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { formatNumber } from "utils/common";
import { getMyPoint } from "features/MyPoint/pointSlice";
import { SERVICE } from "constants/global";
import { Notice } from "components";
import Card from "features/MyPoint/components/Card";
import ErrorDB from "components/ErrorDB";

function MyPoint() {
  const dispatch = useDispatch();

  const { points, total_point, noticesInit, isInLine, isInLinePoint, isInLineNotice } = useSelector(
    (state) => state.point
  );

  useEffect(() => {
    dispatch(getMyPoint({ service: SERVICE }));
  }, []);

  if (!points && !isInLine && !isInLinePoint && !isInLineNotice) return null;

  return (
    <div className="w-80 py-0 py-md-3">
      <Notice noticesInit={noticesInit} isInLine={isInLine || isInLineNotice}/>
      {
        <div>
          <div className="text-center fs-20 fs-sm-18 fw-600 py-3 py-md-4">
            <span>現在の保有ポイント</span>
          </div>
          {isInLine || isInLinePoint ? <ErrorDB/> :
          points?.length < 1 ? (
            <div className="border-color-red-light border-radius-sm-5 p-2 mx-3 mx-md-0 text-center fw-bolder text-red-light">
              保有ポイントはありません
            </div>
          ) : (
            <div>
              <div className="bg-f8 bg-sm-white d-flex flex-column flex-md-row align-items-center">
                <div className="border-point w-sm text-center text-brown py-1 mb-2 my-md-0 bg-white">
                  <h1 className="fw-600 mb-1 name-ellipsis">
                    {formatNumber(total_point)}
                  </h1>
                  <div className="fs-13 fs-sm-9 fw-600">CLAP&WALKポイント</div>
                </div>
                <div className="fs-14 fs-sm-11 ps-0 ps-md-5 sp-sm-05 text-center fw-400 text-md-start">
                  <div className="ps-md-3">
                    <div>
                      3,000ポイント以上貯まると、ご登録の口座にお振込いたします。
                    </div>
                    <a
                      className="fw-600 text-red-light mt-2 d-block"
                      href={PATH.POINT}
                    >
                      <span className="me-2">
                        <i className="bi bi-question-circle-fill"></i>
                      </span>
                      ポイントについて
                    </a>
                  </div>
                </div>
              </div>
              <div className="content-layout mt-3 mt-md-5 py-3 py-md-0 px-3 px-md-0">
                <div className="mb-3 mb-md-2 fw-14 fw-600">保有ポイントの内訳</div>
                <div className="border-color-black border-color-sm-none border-radius-bottom">
                  <div className="row thead gx-0 px-3 py-1 text-center d-none d-md-flex text-white bg-table-layout">
                    <div className="w-col-9">
                      <div className="row gx-0">
                        <div className="col-10">案件名</div>
                        <div className="col-2">ポイント確定日</div>
                      </div>
                    </div>
                    <div className="w-col-3">
                      <div className="row gx-0">
                        <div className="col-5 text-end pe-1">ポイント数</div>
                        <div className="col-7">ポイント有効期限</div>
                      </div>
                    </div>
                  </div>

                  <div className="py-md-3 px-0 px-md-3">
                    {points.map((pointItem, index) => (
                      <Card key={index} pointItem={pointItem} />
                    ))}
                  </div>
                </div>
              </div>
            </div>
          )}
        </div>
      }
    </div>
  );
}

export default MyPoint;
